import { LenderConcession } from '../../interfaces';

export const NavyFederalCreditUnion: LenderConcession = {
  lenderNameRegEx: new RegExp('NAVY'),
  standardMinimumPercent: 2.0,
  minimumDollarAmount: 10,
  apr: 9.9,
};
